
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Checkbox, FormControlLabel } from '@mui/material';

type Props = {
  fieldBlock: checkboxBlock,
  isSelected: number,
  updateProjectOption: (field: string, value: any) => void,
};

const ORANGE_CHECKED_FIELDS = [
  'central_support',
  'use_friction',
  'add_roof_pads_everywhere',
  'use_default_block_capacities',
  'use_default_max_block_north_corner',
  'use_default_flat_slope_roof_snow_load',
];

export default class CheckboxField extends React.PureComponent<Props> {
  render() {
    const { fieldBlock, isSelected, updateProjectOption } = this.props;
    const hasOrangeCheckedState = ORANGE_CHECKED_FIELDS.includes(fieldBlock.apiField);
    const checkedColor = hasOrangeCheckedState ? '#DD2C00' : '#0A3C5D';
    return (
      <div
        className={`checkbox-field-container${hasOrangeCheckedState ? ' checkbox-field-container--orange-checked' : ''}`}
        style={{ marginTop: fieldBlock.margin_ }}
      >
        <FormControlLabel
          control={
            <Checkbox 
              id={fieldBlock.id}
              checked={Boolean(isSelected)}
              onChange={(e) => updateProjectOption(fieldBlock.apiField, e.target.checked)}
              disabled={fieldBlock.is_disabled}
              name={fieldBlock.apiField}
              color="primary"
              sx={{
                padding: '8px',
                '&.Mui-checked': {
                  color: checkedColor,
                },
              }}
            />
          } 
          label={<FormattedMessage id={fieldBlock.label} />}
          sx={{
            margin: 0,
            alignItems: 'flex-start',
            '& .MuiFormControlLabel-label': {
              fontSize: '14px',
              lineHeight: '1.5',
              paddingTop: '8px',
              color: '#374151',
            },
          }}
        />
      </div>
    );
  }
}
